import { createTheme } from '@mui/material/styles';

// Create a theme with white background and red accents
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#d32f2f', // Red primary color
      light: '#ff6659',
      dark: '#9a0007',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#424242', // Dark gray secondary
      light: '#6d6d6d',
      dark: '#1b1b1b',
      contrastText: '#ffffff',
    },
    background: {
      default: '#fafafa', // Light gray background
      paper: '#ffffff', // White paper background
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
    error: {
      main: '#d32f2f',
    },
    warning: {
      main: '#ff9800',
    },
    info: {
      main: '#2196f3',
    },
    success: {
      main: '#4caf50',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 300,
    },
    h2: {
      fontWeight: 400,
    },
    h3: {
      fontWeight: 400,
    },
    h4: {
      fontWeight: 500,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#d32f2f',
          color: '#ffffff',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
        contained: {
          boxShadow: '0 2px 4px rgba(211, 47, 47, 0.2)',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(211, 47, 47, 0.3)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          '&:hover': {
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

// Default severity color mapping (fallback)
export const defaultSeverityColors = {
  Low: {
    main: '#4caf50', // Green
    light: '#81c784',
    dark: '#388e3c',
    contrastText: '#ffffff'
  },
  Medium: {
    main: '#ff9800', // Orange
    light: '#ffb74d',
    dark: '#f57c00',
    contrastText: '#ffffff'
  },
  High: {
    main: '#ff5722', // Red-orange
    light: '#ff8a65',
    dark: '#e64a19',
    contrastText: '#ffffff'
  },
  Critical: {
    main: '#d32f2f', // Red
    light: '#ef5350',
    dark: '#c62828',
    contrastText: '#ffffff'
  }
};

// Default status color mapping (fallback)
export const defaultStatusColors = {
  New: '#2196f3', // Blue
  'In Progress': '#ff9800', // Orange
  'Under Review': '#9c27b0', // Purple
  Resolved: '#4caf50', // Green
  'False Positive': '#757575', // Gray
  Closed: '#424242', // Dark gray
  Open: '#2196f3', // Blue
  Active: '#4caf50', // Green
  Inactive: '#757575', // Gray
  Compromised: '#d32f2f', // Red
  'Under Investigation': '#ff9800', // Orange
  Quarantined: '#ff5722', // Red-orange
};

// Legacy exports for backward compatibility
export const severityColors = defaultSeverityColors;
export const statusColors = defaultStatusColors;
